import { addResourceBundle } from "@trumpf/ux.i18n";
import JSON from "../i18n/de-DE.json";

export type TranslationKey = keyof typeof JSON.translations;

export interface TranslationFile {
    locale: string;
    translations: object;
}

export const loadTranslations = async (locale: string | null): Promise<string> => {
    const localeToLoad = locale || "en-US";
    return await loadJSON(localeToLoad).then((translationFile) => {
        addResourceBundle(translationFile.locale, "mf-service-calls", translationFile.translations);
        return translationFile.locale;
    });
};

const loadJSON = async (locale: string): Promise<TranslationFile> => {
    switch (locale.replace("_", "-").toLowerCase()) {
        // case "bg-bg":
        // case "bg":
        //     return await import("../i18n/bg-BG.json");
        // case "cs-cz":
        // case "cs":
        //     return await import("../i18n/cs-CZ.json");
        case "de-at":
        case "de-ch":
        case "de-de":
        case "de":
        case "de-int":
            return await import("../i18n/de-DE.json");
        case "en-ca":
        case "en-cn":
        case "en-gb":
        case "en-sg":
        case "en-us":
        case "en-int":
        case "en":
            return await import("../i18n/en-US.json");
        case "es-es":
        case "es-mx":
        case "es-int":
        case "es":
            return await import("../i18n/es-ES.json");
        case "fr-fr":
        case "fr-ch":
        case "fr-int":
        case "fr":
            return await import("../i18n/fr-FR.json");
        // case "hu-hu":
        // case "hu":
        //     return await import("../i18n/hu-HU.json");
        case "it-it":
        case "it":
            return await import("../i18n/it-IT.json");
        // case "ja-jp":
        // case "ja":
        //     return await import("../i18n/ja-JP.json");
        // case "ko-kr":
        // case "ko":
        //     return await import("../i18n/ko-KR.json");
        case "nl-nl":
        case "nl":
            return await import("../i18n/nl-NL.json");
        // case "pl-pl":
        // case "pl":
        //     return await import("../i18n/pl-PL.json");
        // case "pt-br":
        // case "pt-pt":
        // case "pt":
        //     return await import("../i18n/pt-PT.json");
        // case "ro-ro":
        // case "ro":
        //     return await import("../i18n/ro-RO.json");
        // case "ru-ru":
        // case "ru-int":
        // case "ru":
        //     return await import("../i18n/ru-RU.json");
        // case "sk-sk":
        // case "sk":
        //     return await import("../i18n/sk-SK.json");
        // case "sv-se":
        // case "sv":
        //     return await import("../i18n/sv-SE.json");
        // case "th-th":
        // case "th":
        //     return await import("../i18n/th-TH.json");
        // case "tr-tr":
        // case "tr":
        //     return await import("../i18n/tr-TR.json");
        // case "vi-vn":
        // case "vi":
        //     return await import("../i18n/vi-VN.json");
        // case "zh-cn":
        // case "zh-tw":
        // case "zh-int":
        // case "zh":
        //     return await import("../i18n/zh-CN.json");
        default:
            return await import("../i18n/en-US.json");
    }
};

export default loadTranslations;
